// src/components/ZoomableImage/ZoomableImage.jsx
import React, { useState, useEffect, useCallback } from 'react';
import './ZoomableImage.css';

const ZoomableImage = ({ src, alt, className = '', wide = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const close = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, close]);

  return (
    <>
      <button
        type="button"
        className="zoomable-image-trigger"
        onClick={() => setIsOpen(true)}
        aria-label={`Enlarge image: ${alt}`}
      >
        <img src={src} alt={alt} className={className} />
        <span className="zoomable-image-hint">Click to enlarge</span>
      </button>

      {isOpen && (
        <div className={`zoomable-image-overlay${wide ? ' zoomable-image-overlay--wide' : ''}`} onClick={close}>
          <button type="button" className="zoomable-image-close" onClick={close} aria-label="Close">
            &times;
          </button>
          <img
            src={src}
            alt={alt}
            className={`zoomable-image-full${wide ? ' zoomable-image-full--wide' : ''}`}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
};

export default ZoomableImage;
